import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { AdminComponent } from './admin/admin.component';
import { MsalGuard } from '@azure/msal-angular';
import { RestrictedComponent } from './restricted/restricted.component';
import { CreateOrEditComponent } from './admin/createredit/createoredit.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { CreateOrUpdateExceptionComponent } from "./admin/createorupdateexception/create-or-update-exception.component";
import { NavbarComponent } from "./admin/navbar/navbar.component";
export const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        title: "SJP Pendeltågen",
        component: HomeComponent,
    },
    {
        path: 'admin',
        title: "SJP Pendeltåg",
        component: NavbarComponent,
        canActivate: [MsalGuard],
        canActivateChild: [MsalGuard],
        children: [
            {
                path: '',
                component: AdminComponent,
            },{
                path: 'create',
                component: CreateOrEditComponent,
            },
            {
                path: 'edit/:remarkId',
                component: CreateOrEditComponent,
            },
            {
                path: 'edit/:remarkId/exception-create',
                component: CreateOrUpdateExceptionComponent,
            },
            {
                path: 'edit/:remarkId/exception-edit/:exceptionId',
                component: CreateOrUpdateExceptionComponent,
            },
        ]
    },
    {
        path: "signin-oidc",
        component: UserInfoComponent,
      },
    {
        path: "admin/signin-oidc",
        component: UserInfoComponent,
    },
    {
        path: "restricted",
        component: RestrictedComponent,
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
